
var REACT_METHODS = [
  'constructor',
  'render',
  'forceUpdate',
  'setState',
  'isMounted',
  'replaceState',
  'hasOwnProperty',
  'componentWillMount',
  'componentDidMount',
  'componentWillReceiveProps',
  'shouldComponentUpdate',
  'componentWillUpdate',
  'componentDidUpdate',
  'componentWillUnmount'
]

export default (self) => {

  for (const key of getAllPropertyNames(self)) {
    let val = null

    if (REACT_METHODS.includes(key) ||
      key.startsWith('_') ) continue

    try {
      val = self[key];
    } catch (err) {
      let pd = null;
      let obj = self;

      do {
        pd = Object.getOwnPropertyDescriptor(obj, key);
        if ( pd != null ) {
          if ( pd.get ) {
            console.log('\nNOTE: potential issue with getter functions, so:');
            console.log('  1) initialize the getter/setter inside the getter/setter (not ideal)');
            console.log('  2) call autoBindI at end of final child (not ideal)');
            console.log('  3) manually call autoBindI');
            console.log('  4) avoid getter/setters');
            throw new Error('getter implementation issue with auto-bind-inheritance.');
          }
        }
      } while( (obj = Object.getPrototypeOf(obj)) )
    }

    var doBind = typeof val === 'function' &&
      !self[key].name.startsWith('bound ')
    if (doBind) {
      self[key] = val.bind(self)
    }
  }



  /**
   * Get all property names by walking up prototype chain
   * @param {*} obj
   * @return {array}
   */
  function getAllPropertyNames( obj ) {
    let props = [];

    do {
      Object.getOwnPropertyNames( obj )
        .forEach(( prop ) => {
          if ( props.indexOf( prop ) === -1 ) {props.push( prop );}
        });
    } while ( (obj = Object.getPrototypeOf( obj )) )

    return props;
  }

  return self
}



// WEBPACK FOOTER //
// ./src/lib/autoBind.js